import {Datoformatering} from "../tjenester/Datoformatering";

export function formaterDatoMedKlokkeslettFilterForInjisering() {
    return [Datoformatering.regNavn, formaterDatoMedKlokkeslettFilter];
}

/**
 * Formaterer angitt dato som streng.
 * Delegerer til Datoformatering.somKalenderMedKlokkeslett().
 */
export function formaterDatoMedKlokkeslettFilter(datoformatering: Datoformatering): Function {
    return function (dato: Date) {
        return datoformatering.somKalenderMedKlokkeslett(dato);
    }
}

